/**
 * Converts data to binary representation
 * @param {string | number | boolean} data
 * @returns Byte array in binary representation (UTF-8 encoded)
 */
function convertToBinary(data) {
    const utf8Data = unescape(encodeURIComponent(data));
    const buffer = new ArrayBuffer(utf8Data.length);
    const udata = new Uint8Array(buffer);
    for (let i = 0, len = utf8Data.length; i < len; i++) {
        udata[i] = utf8Data.charCodeAt(i);
    }
    return udata;
}

export { convertToBinary };
